import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Dice3Icon } from "lucide-react";
import cc from '../images/PBT REMAIMING IMG (2).webp';
import c1 from '../images/IMG (34).webp';
import { useDispatch, useSelector } from "react-redux";
import { getActiveBlogs } from "../../App/Slices/blogSlice";

const SixCardSlider = ({ blogs, heading }) => {
  const dispatch = useDispatch()
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const CustomPrevArrow = ({ onClick }) => (
    <button
      className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow"
      onClick={onClick}
    >
      ‹
    </button>
  );

  const CustomNextArrow = ({ onClick }) => (
    <button
      className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow"
      onClick={onClick}
    >
      ›
    </button>
  );


const blogCount = blogs?.length || 0;

const settings = {
  dots: blogCount > 1,
  infinite: blogCount > 3,
  speed: 500,
  slidesToShow: 3, // Always 3
  slidesToScroll: 1,
  rows: 1,
  autoplay: blogCount > 1,
  autoplaySpeed: 3000,
  arrows: blogCount > 1,
  centerMode: blogCount === 1,  // 👈 Important
  centerPadding: blogCount === 1 ? "53%" : "0px", // 👈 Adjust width
  nextArrow: blogCount > 1 ? <CustomNextArrow /> : null,
  prevArrow: blogCount > 1 ? <CustomPrevArrow /> : null,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      },
    },
  ],
};



  return (
    <div className="container my-3 letest-articals-sections-blog">
      {blogs?.length > 0 &&
        <>
          <h1 className="text-center mb-5">{heading}</h1>
          <Slider {...settings}>
            {blogs?.map((article) => (
              <div key={article?.id} className="card-container">
                <div className="card">
                  <img src={`${baseUrl}/${article?.image}`} className="card-img-top" alt={article?.title} loading='lazy' />
                  <div className="card-body text-center">
                    {/* <span className="badge bg-primary">Blog</span> */}
                    <h5 className="card-title">{article?.title}</h5>
                    <p className="card-text" dangerouslySetInnerHTML={{ __html: article?.description }} />
                    <a href={`/blog-details/${article?.slug}`} className="btn btn-primary mt-auto read-more-blogs-btn text-center">Read more</a>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </>
      }
      <img src={c1} alt="Welcome " className='right-side-half-circle-blogs' loading='lazy' />

    </div>
  );
};

export default SixCardSlider;
